import { api, formatApiErrorDetail } from "@/lib/api";

const PLAN_LOOKUP_KEYS = {
  starter: "starter_monthly",
  professional: "professional_monthly",
  business: "business_monthly",
};

export async function startPlanCheckout(tier) {
  const lookup_key = PLAN_LOOKUP_KEYS[tier];
  if (!lookup_key) throw new Error("Unknown plan");
  try {
    const { data } = await api.post("/payments/checkout", {
      lookup_key,
      origin_url: window.location.origin,
    });
    if (data?.checkout_url || data?.url) {
      window.location.assign(data.checkout_url || data.url);
      return true;
    }
    throw new Error("Missing checkout URL");
  } catch (err) {
    throw new Error(formatApiErrorDetail(err.response?.data?.detail || err.message));
  }
}

export async function openBillingPortal({ returnPath = "/settings" } = {}) {
  try {
    const { data } = await api.post("/billing/portal", {
      origin_url: window.location.origin,
      return_path: returnPath,
    });
    if (data?.portal_url) {
      window.location.assign(data.portal_url);
      return true;
    }
    throw new Error("Missing portal URL");
  } catch (err) {
    throw new Error(formatApiErrorDetail(err.response?.data?.detail || err.message));
  }
}